import { environment } from "../environment";
import { UserNotification } from "../models/userNotification";
import api from "./api";


export async function getNotificationByUser(userId: number, isRead: string): Promise<UserNotification[]> {
  const isReadValue = isRead === 'true' ? '1' : isRead === 'false' ? '0' : '';
  const baseUrl = environment.api.notification.getByUser
    .replace('{userId}', String(userId))
    .replace('{isRead}', String(isReadValue));
  
  return await api.get(baseUrl).then(res => res.data.success);
}

export async function getNotificationByClubUser(userId: number, clubId: number, isRead: string): Promise<UserNotification[]> {
  const isReadValue = isRead === 'true' ? '1' : isRead === 'false' ? '0' : '';
  const baseUrl = environment.api.notification.getByClubUser
    .replace('{userId}', String(userId))
    .replace('{clubId}', String(clubId))
    .replace('{isRead}', String(isReadValue));
  
  return await api.get(baseUrl).then(res => res.data.success);
}

export async function markAsRead(notificationId: number): Promise<UserNotification> {
  const baseUrl = environment.api.notification.markAsRead
    .replace('{notificationId}', String(notificationId));
  
  return await api.get(baseUrl).then(res => res.data.success);
}
